// @ts-expect-error React import required to render in Jira SSR
import React from 'react';
import { useCallback } from 'react';

// eslint-disable-next-line @atlaskit/platform/no-barrel-entry-imports -- Remote placements must use the host-shared Crossflow context.
import { useCrossFlow } from '@atlassiansox/cross-flow-support';
import { CrossflowRecommendationBanner } from '../../common/crossflow-recommendation-banner';
import { useIntl } from 'react-intl';
import confluenceIconSvg from '../assets/confluence-icon.svg';
import { registeredContent } from '../placements/in-app-v2/jira-for-you-crossflow-solutions/content';

const HAMS_PRODUCT_ID = 'confluence.ondemand';

const CROSSFLOW_JOURNEY = 'get-started';

const i18n = registeredContent.default;

type ConfluenceRecommendationBannerProps = {
	dismiss: () => void;
};

export const ConfluenceRecommendationBanner = ({
	dismiss,
}: ConfluenceRecommendationBannerProps): JSX.Element => {
	const { formatMessage } = useIntl();
	const crossflow = useCrossFlow();

	const handleCtaClick = useCallback(() => {
		if (crossflow.isEnabled) {
			crossflow.apiV1
				.open({
					targetProduct: HAMS_PRODUCT_ID,
					journey: CROSSFLOW_JOURNEY,
					sourceComponent: 'forYouRecommendation',
					sourceContext: 'tryItNow',
					v1: true,
				})
				.catch(() => {});
		}
	}, [crossflow]);

	return (
		<CrossflowRecommendationBanner
			icon={<img src={confluenceIconSvg} alt="" width="40" height="40" />}
			title={formatMessage(i18n.title)}
			description={formatMessage(i18n.description)}
			buttonName={formatMessage(i18n.buttonName)}
			dismissLabel={formatMessage(i18n.dismissLabel)}
			onCtaClick={handleCtaClick}
			dismiss={dismiss}
			analyticsId="confluenceCrossflowRecommendation"
		/>
	);
};
